import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import Header from "../Header";
import "./index.css";
import Footer from "../Footer";
import RedesSociais from "../RedesSociais";

export default function Contato() {
  const form = useRef();
  const [enviado, setEnviado] = useState(false);

  const fnEnviarFormulario = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_4hfivsg",
        "template_vold7fb",
        form.current,
        "rwqOaaFi-CbganR0P"
      )

      // ricardozuqueto
      // ricardozuqueto
      // ricardozuqueto
      // ricardozuqueto
      // ricardozuqueto
      // .sendForm(
      //   "service_7z5wrzm",
      //   "template_a6q4hfl",
      //   form.current,
      //   "bMRy8pLjmMRAas5jO"
      // )
      .then(
        (result) => {
          setEnviado(true);
          setTimeout(() => {
            setEnviado(false);
          }, 5000);
          form.current.reset();
        },
        (error) => {
          console.error(error);
        }
      );
  };

  return (
    <>
      <Header />
      <div className="divContato ">
        <div
          className="row"
          style={{ marginTop: 280, maxWidth: 1500, width: "100%" }}
        >
          {/* <div className="col-md-6 d-flex justify-content-center align-items-center p-4">
            <div className="divTextoContato">
              <div className="tituloContato">Fala com a gente, bb</div>
              <div className="textoContato">
                Quer fazer um filme maneiro pro seu cliente ou para o seu
                próprio negócio? Manda uma breve mensagem contanto do projeto e
                entraremos em contato!
                <br />
                <br />
                <br />
                <RedesSociais />
              </div>
            </div>
          </div> */}
          <div
            className="col-md-7 d-flex justify-content-center align-items-center p-4 text-center text-md-start"
            sty
          >
            <div className="divTextoContato">
              <div className="tituloContato">Fala com a gente, bb</div>
              <div className="d-flex justify-content-center">
                <RedesSociais />
              </div>
            </div>
          </div>
          {/* <div className="col-md-6 d-flex justify-content-center align-items-center p-4">
            {enviado ? (
              <div className="mensagemEnviada">
                Mensagem enviada com sucesso!
              </div>
            ) : (
              <form
                ref={form}
                onSubmit={fnEnviarFormulario}
                className="divFormulario"
              >
                <label className="tituloContatoFormulario mt-5 mt-md-0">
                  E-mail
                </label>
                <input className="emailInput" type="email" name="email" />

                <label className="tituloContatoFormulario mt-4">Message</label>
                <textarea className="mensagemInput" name="message" />
                <div className="d-flex justify-content-end mt-4">
                  <input
                    className="botaoFormulario"
                    type="submit"
                    value="Enviar"
                  />
                </div>
              </form>
            )}
          </div>  */}
          <div className=" ps-5 col-md-5 d-flex flex-column justify-content-center align-items-center overflow-hidden ">
            <div
              className="p-2 d-flex w-100 flex-column pointer text-center text-md-start hoverZoom "
              onClick={() => window.open("mailto:doisbar@filofilmes.com")}
            >
              <div style={{ color: "#e48b38", fontSize: 11, marginBottom: -7 }}>
                creative director
              </div>
              <div style={{ fontSize: 30, color: "#fff", fontWeight: 300 }}>
                bárbara napolitano
              </div>
              <div style={{ color: "#b9b9b9", fontSize: 11, marginTop: -7 }}>
                doisbar@filofilmes.com
              </div>
            </div>
            <div
              className="p-2 d-flex w-100 flex-column pointer text-center text-md-start hoverZoom "
              onClick={() => window.open("mailto:trovis@filofilmes.com")}
            >
              <div style={{ color: "#e48b38", fontSize: 11, marginBottom: -7 }}>
                founder & director
              </div>
              <div style={{ fontSize: 30, color: "#fff", fontWeight: 300 }}>
                erik trovilho
              </div>
              <div style={{ color: "#b9b9b9", fontSize: 11, marginTop: -7 }}>
                trovis@filofilmes.com
              </div>
            </div>
            <div
              className="p-2 d-flex w-100 flex-column pointer text-center text-md-start hoverZoom "
              onClick={() => window.open("mailto:marcosbatista@filofilmes.com")}
            >
              <div style={{ color: "#e48b38", fontSize: 11, marginBottom: -7 }}>
                project manager
              </div>
              <div style={{ fontSize: 30, color: "#fff", fontWeight: 300 }}>
                marcos batista
              </div>
              <div style={{ color: "#b9b9b9", fontSize: 11, marginTop: -7 }}>
                doisbar@filofilmes.com
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
